export default "__VITE_ASSET___x3xHRvB__"